import Chart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';
import { energyColors } from './chartConfig';

interface ApexRadialBarProps {
  value: number;
  size?: number;
  color?: string;
  trackColor?: string;
}

export function ApexRadialBar({
  value,
  size = 60,
  color = energyColors.solar,
  trackColor = 'rgba(255,255,255,0.1)',
}: ApexRadialBarProps) {
  // Validate value: ensure finite number in valid range (0-100)
  const safeValue = Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0;

  const options: ApexOptions = {
    chart: {
      type: 'radialBar',
      sparkline: { enabled: true },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '55%',
        },
        track: {
          background: trackColor,
        },
        dataLabels: {
          show: true,
          name: { show: false },
          value: {
            show: true,
            fontSize: '14px',
            fontWeight: 600,
            color: color,
            offsetY: 5,
            formatter: (val) => `${Math.round(val)}%`,
          },
        },
      },
    },
    colors: [color],
    stroke: {
      lineCap: 'round',
    },
  };

  const series = [safeValue];

  return (
    <Chart
      type="radialBar"
      options={options}
      series={series}
      height={size}
      width={size}
    />
  );
}
